import declare from 'dojo/_base/declare';
import connect from 'dojo/_base/connect';
import lang from 'dojo/_base/lang';
import arr from 'dojo/_base/array';
import color from 'dojo/_base/Color';
import keys from 'dojo/keys';
import _WidgetBase from 'dijit/_WidgetBase';
import _TemplatedMixin from 'dijit/_TemplatedMixin';
import _WidgetsInTemplateMixin from 'dijit/_WidgetsInTemplateMixin';
import template from './SelectRoomDialog.html?raw';
import registry from 'dijit/registry';
import on from 'dojo/on';
import domAttr from 'dojo/dom-attr';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import domConstruct from 'dojo/dom-construct';
import mouse from 'dojo/mouse';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
export default declare("WidgetCollection.Occurrence.SelectRoomDialog.SelectRoomDialog", [_WidgetBaseSP], {

        templateString: template,

        returnCompleteEntities: false,

        callback: function(){},

        selection: {
            building: null,
            buildingpart: null,
            level: null,
            room: null,
            targettype: null,
            _label: null
        },

        _presetData: null,

        _buildings: [],
        _buildingParts: [],
        _rooms: [],
        _levels: [],

        layersNeeded: 4, // 3 = Gebäude + Teil + Level + Raum

        extendedData: "", // zusätzliche Requestparameter...

        _onClick_Close: function(){
            this.close(0);
        },
        _onClick_Button_Cancel: function(evt){
            this.close(0);
        },
        _onClick_Button_OK: function (evt) {

            var bSuccess = this.validate();

            if (bSuccess != true) {
                //this.close(0);
            } else {
                this.close(1);
            }
        },

        preset: function (data) {
            this.selection = data;
        },

        _setCallbackAttr: function(value){
            this.callback = value;
        },

        _onKeyUp_Dlg: function(evt){
            if (evt.keyCode == 13) {
                this.close(1);
            }
            if (evt.keyCode == 27) {
                this.close(0);
            }
        },

        _setOkAttr: function (value) {
            if (value === true) {
                domStyle.set(this.btn_ok, "display", "block");
            } else {
                domStyle.set(this.btn_ok, "display", "none");
            }
        },

        _setCancelAttr: function(value){
            if(value === true){
                domStyle.set(this.btn_cancel, "display", "block");
            }else{
                domStyle.set(this.btn_cancel, "display", "none");
            }
        },

        _setOKStyle: function () {

            //console.log("selectroomdialog _setOKStyle");

            var disableStyleFct = domClass.add;
            var hoverStyleFct = domClass.add;
            if (this.validate() == true) {
                disableStyleFct = domClass.remove;
            } else {
                hoverStyleFct = domClass.remove;
            }

            disableStyleFct(this.btn_ok, "w3-disabled");
            hoverStyleFct(this.btn_ok, "mds-hover-bright");
        },

        validate: function () {
            var bSuccess = true;

            console.log("selectroom validation", this.layersNeeded, this.selection);

            if (this.layersNeeded >= 3 && (this.selection.room == null || this.selection.level == null || this.selection.level == "null")) {
                bSuccess = false;
            } else if (this.layersNeeded >= 1 && this.selection.level == null || this.selection.level == "null") {
                bSuccess = false;
            } else if (this.layersNeeded >= 0 && this.selection.building == null) {
                bSuccess = false;
            }

            return bSuccess;
        },

        _setNeededLayersAttr: function (value) {
            this.layersNeeded = value;

            domClass.add(this.sectionBuilding, "w3-hide");
            //domClass.add(this.sectionBuildingpart, "w3-hide");
            domClass.add(this.sectionLevel, "w3-hide");
            domClass.add(this.sectionRoom, "w3-hide");

            if (true) {//value >= 0) {
                domClass.remove(this.sectionBuilding, "w3-hide");
            }

            //if (value >= 1) {
            //    domClass.remove(this.sectionBuildingpart, "w3-hide");
            //}

            if (value >= 2) {
                domClass.remove(this.sectionLevel, "w3-hide");
            }

            if (value >= 3) {
                domClass.remove(this.sectionRoom, "w3-hide");
            }

            switch (value) {
                case 0:
                    this.selection.targettype = "building";
                    break;

                case 1:
                    this.selection.targettype = "buildingpart";
                    break;

                case 2:
                    this.selection.targettype = "level";
                    break;

                case 3:
                    this.selection.targettype = "room";
                    break;
            }

        },

        _renderBuildings: function(resetData){
            domAttr.set(this.buildingNode, "innerHTML", "");
            console.log("renderBuildings", resetData, this.selection, this._buildings);
            var option = domConstruct.create("option", {
                innerHTML: this.translations["General_DropdownBlank_Choose"],//"-- bitte wählen --",
                "disabled": "true",
                "selected": "true",
                value: null
            }, this.buildingNode);

            for( var i = 0; i < this._buildings.length; i++){
                var entity = this._buildings[i];

                if (entity.EL_level.length > 0 || this.layersNeeded == 0) { // entweder es gibt Stockwerke oder sie werden nicht benötigt
                    var option = domConstruct.create("option", {
                        innerHTML: entity.tmp_label,
                        value: entity.ID
                    }, this.buildingNode);

                    if (this.selection.building == entity.ID) {
                        domAttr.set(option, "selected", true);
                    }
                }

                
            }

            this._onChange_Building(resetData);
        },

        _onChange_Building: function (resetData) {
            //domAttr.set(this.buildingPartNode, "innerHTML", "");
            //domAttr.set(this.buildingPartNode, "disabled", "true");
            domAttr.set(this.levelNode, "innerHTML", "");
            domAttr.set(this.levelNode, "disabled", "true");
            domAttr.set(this.roomNode, "innerHTML", "");
            domAttr.set(this.roomNode, "disabled", "true");


            if (resetData === false) {
            } else {
                this.selection.buildingpart = null;
                this.selection.level = null;
                this.selection.room = null;
            }

            this.selection.building = domAttr.get(this.buildingNode, "value");
            this.selection._label = this.buildSelectionLabel();

            this._setOKStyle();


            if (this.layersNeeded == 0) { // keine Unterebenen nötig, hier kann abgebrochen werden
                return;
            }
            //console.log("change building", domAttr.get(this.buildingNode, "value"));
            
            for (var i = 0; i < this._buildings.length; i++) {
                var entity = this._buildings[i];

                if (entity.ID == this.selection.building) {
                    console.log("selected building", entity);
                    this._levels = entity.EL_level;
                    this._renderLevels(resetData);
                    domAttr.remove(this.levelNode, "disabled");
                    break;
                }
            }
        },

        _renderBuildingParts: function (resetData) {
            domAttr.set(this.buildingPartNode, "innerHTML", "");

            if (bpEntities == null || typeof (bpEntities) == "undefined") {
                var bpEntities = this._buildingParts;
            }

            //console.log("render buildingparts", bpEntities);

            var option = domConstruct.create("option", {
                innerHTML: this.translations["General_DropdownBlank_Choose"],//"-- bitte wählen --",
                value: null,
                "disabled": "true",
                "selected": "true"
            }, this.buildingPartNode);

            for (var i = 0; i < bpEntities.length; i++) {
                var entity = bpEntities[i];

                var option = domConstruct.create("option", {
                    innerHTML: entity.Name_number,
                    value: entity.ID
                }, this.buildingPartNode);

                if (this.selection.buildingpart == entity.ID) {
                    domAttr.set(option, "selected", true);
                    //domAttr.set(dummyOption, "selected", false);
                }
            }

            this._onChange_Buildingpart(resetData);
        },


        _onChange_Buildingpart: function (resetData) {
            domAttr.set(this.roomNode, "innerHTML", "");
            domAttr.set(this.roomNode, "disabled", "true");


            if (resetData === false) {
            } else {
                this.selection.room = null;
            }

            var newBP = domAttr.get(this.buildingPartNode, "value");
            this.selection.buildingpart = newBP;

            this._setOKStyle();


            if (newBP == null || newBP == "" || typeof (newBP) == "undefined" || newBP == "null") {
                this.selection.buildingpart = null;
                this._rooms = null;
                this._renderRooms(null);
                return;
            } 

            //console.info("changed buildingPart", this.selection);

            this.StandbyStart(this.sectionRoom);
            this.RequestManager.post(window.appRoot + "Occurrence/GetRoomListJSON",
                {
                    "buildingpartId": this.selection.buildingpart,
                    "levelNameId": this.selection.level 
                },

                lang.hitch(this, function (response) {
                    this.StandbyStop();

                    //var rooms = JSON.parse(response);
                    var rooms = response;
                    this._rooms = rooms;

                    //console.log( "rooms", rooms );
                    this._renderRooms(rooms);
                    domAttr.remove(this.roomNode, "disabled");
                }),
                lang.hitch(this, function (error) {
                    this.StandbyStop();
                    //console.log("login-error:", error);
                    domAttr.set(this.messageNode, "innerHTML", error.Message);
                })
            );

                      
        },

        _renderLevels: function (resetData) {
            domAttr.set(this.levelNode, "innerHTML", "");

            var levelEntities = null;

            if (levelEntities == null || typeof (levelEntities) == "undefined") {
                var levelEntities = this._levels;
            }

            console.log("render levels", resetData, levelEntities);

            if (levelEntities != null) {

                var option = domConstruct.create("option", {
                    innerHTML: this.translations["General_DropdownBlank_Choose"],//"-- bitte wählen --",
                    value: null,
                    "disabled": "true",
                    "selected": "true"
                }, this.levelNode);

                for (var i = 0; i < levelEntities.length; i++) {
                    var entity = levelEntities[i];

                    if (entity.ref_level_designation != null && entity.ref_level_designation.ID != "") {
                        var option = domConstruct.create("option", {
                            innerHTML: entity.ref_level_designation.Name,
                            value: entity.ref_level_designation.ID
                        }, this.levelNode);

                        if (this.selection.level == entity.ID) {
                            domAttr.set(option, "selected", true);
                            //domAttr.set(dummyOption, "selected", false);
                        }
                    }
                }
            }

            this._onChange_Level(resetData);
        },

        _onChange_Level: function (resetData) {
            domAttr.set(this.roomNode, "innerHTML", "");
            domAttr.set(this.roomNode, "disabled", "true");
            //domAttr.set(this.buildingPartNode, "innerHTML", "");
            //domAttr.set(this.buildingPartNode, "disabled", "true");


            if (resetData === false) {
            } else {
                this.selection.room = null;
                this.selection.buildingpart = null;
            }
            var newLevel = domAttr.get(this.levelNode, "value");
            this.selection.level = newLevel;
            this.selection._label = this.buildSelectionLabel();

            //console.info("changed level", this.selection);
            this._setOKStyle();


            if (newLevel == null || newLevel == "" || typeof (newLevel) == "undefined" || newLevel == "null") {
                this._rooms = null;
                //this._renderBuildingParts(resetData);

                return;
            }

            var requestData = {
                "buildingId": this.selection.building,
                "levelNameId": this.selection.level,
                "extendedData": this.extendedData
            };

            this.StandbyStart(this.sectionRoom);
            this.RequestManager.post(window.appRoot + "Occurrence/GetRoomListJSON",
                {
                    "jsonData": JSON.stringify(requestData)
                },

                lang.hitch(this, function (response) {
                    this.StandbyStop();

                    //var rooms = JSON.parse(response);
                    var rooms = response;
                    this._rooms = rooms;

                    //console.log( "rooms", rooms );
                    this._renderRooms(rooms);
                    domAttr.remove(this.roomNode, "disabled");
                }),
                lang.hitch(this, function (error) {
                    this.StandbyStop();
                    //console.log("login-error:", error);
                    domAttr.set(this.messageNode, "innerHTML", error.Message);
                })
            );

            
        },

        _onChange_Room: function(){
            this.selection.room = domAttr.get(this.roomNode, "value");
            //console.info("changed room", this.selection);
            this.selection._label = this.buildSelectionLabel();

            this._setOKStyle();
        },

        _renderRooms: function(roomEntities){
            domAttr.set(this.roomNode, "innerHTML", "");

            console.log("render rooms", roomEntities);

            if (roomEntities == null || typeof (roomEntities) == "undefined") {
                return;
            }

            var option = domConstruct.create("option", {
                innerHTML: this.translations["General_DropdownBlank_Choose"],//"-- bitte wählen --",
                value: null,
                "disabled": "true",
                "selected": "true"
            }, this.roomNode);

            for( var i = 0; i < roomEntities.length; i++){
                var entity = roomEntities[i];

                var option = domConstruct.create("option", {
                    innerHTML: entity.tmp_label,
                    value: entity.ID
                }, this.roomNode);

                if( this.selection.room == entity.ID ){
                    domAttr.set(option, "selected", true);
                }
            }
        },

        

        loadBuildings: function(resetData){

            this.StandbyStart(this.sectionBuilding);

            // progressbar über die Buildingnode legen
            this.startProgressbar(this.buildingNode);

            var exData = this.extendedData;
            if (typeof (this.extendedData) == "object" && this.extendedData != null) {
                exData = JSON.stringify(this.extendedData);
            } 

            this.RequestManager.post(window.appRoot + "Occurrence/GetBuildingListJSON",
                {
                    "jsonData": exData
                },
                lang.hitch(this, function (resetData, response) {
                    this.StandbyStop();
                    this.stopProgressbar();

                    //var buildings = JSON.parse(response);
                    var buildings = response;
                    this._buildings = buildings;

                    //console.log( "buildings", buildings );
                    this._renderBuildings(resetData);
                    domAttr.remove(this.buildingNode, "disabled");
                }, resetData),
                lang.hitch(this, function (error) {
                    this.StandbyStop();
                    domAttr.set(this.messageNode, "innerHTML", error.Message);
                })
            );
        },


        _setHeaderAttr: function (value) {
            domAttr.set(this.headerNode, "innerHTML", value);
        },

        _getHeaderAttr: function () {
            return domAttr.get(this.headerNode, "innerHTML");
        },

        show: function(){
            domStyle.set(this.modalDlg, "display", "block");
            console.debug("SelectRoomDialog show", this.selection);
            this.loadBuildings(false);
        },

        close: function(result){
            domStyle.set(this.modalDlg, "display", "none");

            if (typeof (result) == "undefined") {
                result = 0;
            }

            if (this.returnCompleteEntities == true) {
                if (this.selection.building != null) {
                    for (var i = 0; i < this._buildings.length; i++) {
                        if (this.selection.building == this._buildings[i].ID) {
                            this.selection.building = this._buildings[i];
                            break;
                        }
                    }
                }

                if (this.selection.buildingpart != null) {
                    for (var i = 0; i < this._buildingParts.length; i++) {
                        if (this.selection.buildingpart == this._buildingParts[i].ID) {
                            this.selection.buildingpart = this._buildingParts[i];
                            break;
                        }
                    }
                }

                if (this.selection.level != null) {
                    for (var i = 0; i < this._levels.length; i++) {
                        if (this.selection.level == this._levels[i].ID) {
                            this.selection.level = this._levels[i];
                            break;
                        }
                    }
                }

                if (this.selection.room != null) {
                    for (var i = 0; i < this._rooms.length; i++) {
                        if (this.selection.room == this._rooms[i].ID) {
                            this.selection.room = this._rooms[i];
                            break;
                        }
                    }
                }

            }

            //  callback-function nahezu in echtzeit aufrufen. aber asynchron ...
            // weitere Parameter zurückgeben, zB. Textinput?
            //
            setTimeout(lang.partial(this.callback, result, this.selection ), 1);


            //  selbstzerstörung in 1 Sekunde :-)
            //
            setTimeout(lang.hitch(this, "destroy"), 1000);
        },

        buildSelectionLabel: function () {
            var label = "";

            //console.log("selectionlabel", this._buildings, this.selection);
            if (this.selection.room != null) {
                for (var i = 0; i < this._rooms.length; i++) {
                    var room = this._rooms[i];

                    if (room.ID == this.selection.room) {

                        //label = room.OKS_room;
                        label = room.dispname;
                        //label = room.tmp_label;
                        break;
                    }
                }
            }

            else if (this.selection.level != null) {
                for (var i = 0; i < this._levels.length; i++) {
                    var level = this._levels[i];

                    if (level.ID == this.selection.level) {

                        //label = level.OKS_level;
                        label = level.dispname;

                        //console.debug("selected levelname: ", level, this.selection);
                        // im levelname ist eine Liste von Levels
                        // zusammen mit der ID des Gebäudes ergibt sich da ein eindeutiger Eintrag
                        // und da steht dann auch das richtigie tmp_label bezogen auf das Gebäude/den Gebäudeteil
                        for (var x = 0; x < level.EL_levels.length; x++) {
                            var realLevel = level.EL_levels[x];

                            if (realLevel.ref_building.ID == this.selection.building && realLevel.ref_building_part.ID == this.selection.buildingpart) {
                                label = realLevel.tmp_label;
                            }
                        }

                        break;
                    }
                }
            }

            else if (this.selection.building != null) {
                for (var i = 0; i < this._buildings.length; i++) {
                    var building = this._buildings[i];

                    if (building.ID == this.selection.building) {

                        //label = building.Street + " (" + building.OKS_building + ")";
                        label = building.dispname;
                        //label = building.tmp_label;
                        break;
                    }
                }
            }

            if (typeof (label) != "undefined") {
                return label;
            }


            return "";
        },

        startProgressbar: function (targetNode) {
            //domConstruct.place(this.progressbarContainer, targetNode);
            //domClass.remove(this.progressbarContainer, "w3-hide");
        },

        stopProgressbar: function () {
            //domClass.add(this.progressbarContainer, "w3-hide");
            //domConstruct.place(this.progressbarContainer, this.domNode);
        },

        postMixInProperties: function(){
            this.inherited(arguments); // standard code aus basisklasse

            this._buildings = [];
        },
        postCreate: function () { // markup wurde eingelesen und im html-document angelegt
            this.inherited(arguments);

            this.placeAt(document.body);
        },
        startup: function () {  // ganz am ende nach instanzierung. zb zum größe berechnen oder abhängigkeiten anderer widgets prüfen
            this.inherited(arguments);
        },
        destroy: function () {
            this.inherited(arguments);
        }


    })
